import React from "react";
import { Card } from "antd";

import LayoutDefault from "../../shared/LayoutDefault";

import * as AdminLogs from "../AdminLogs";

const DashboardView = () => (
  <LayoutDefault>
    <AdminLogs.Data>
      {(data) =>
        data && (
          <Card title="Recent logs" bodyStyle={{ padding: "0" }}>
            <AdminLogs.View {...data} />
          </Card>
        )
      }
    </AdminLogs.Data>
  </LayoutDefault>
);

export default DashboardView;
